import { render, staticRenderFns } from "./unpaidOrderList.vue?vue&type=template&id=2ff21602&scoped=true&"
import script from "./unpaidOrderList.vue?vue&type=script&lang=js&"
export * from "./unpaidOrderList.vue?vue&type=script&lang=js&"
import style0 from "./unpaidOrderList.vue?vue&type=style&index=0&id=2ff21602&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff21602",
  null
  
)

export default component.exports